import { UtilS } from '../../../Util/S/Function/module/UtilS.js';

export const PRODUCT_STORY_MAX_WIDTH = UtilS.isNessApp() ? 1824 : 912;
export const PRODUCT_STORY_MAX_HEIGHT = 10000;
